import { useTranslation } from "react-i18next";
import { Wallet } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// بطاقة المبلغ المستحق — واضحة، مركزة، فيها العملة صراحةً + اسم الجهة.
export const MyBillSignAmount = ({ bill, company, cashbox, branch }) => {
  const { t } = useTranslation();
  const cur = (bill.currency || branch?.currency || cashbox?.currency || "").toUpperCase();
  return (
    <div className="rounded-3xl bg-gradient-to-br from-emerald-600 via-emerald-700 to-emerald-800 p-6 text-center text-white shadow-xl"
         data-testid="my-amount-card">
      <p className="flex items-center justify-center gap-2 text-xs font-bold opacity-90">
        <Wallet className="h-4 w-4" /> {t("acct.bills.mysign.amountDue")}
      </p>
      <p className="mt-3 flex items-baseline justify-center gap-2" dir="ltr">
        <span className="text-sm font-black opacity-80">{cur}</span>
        <span className="text-5xl font-black tracking-tight" data-testid="my-amount-value">{fmt(bill.total)}</span>
      </p>
      {company?.name ? (
        <p className="mt-4 inline-block rounded-full bg-white/15 px-3 py-1 text-xs font-bold backdrop-blur">
          {t("acct.bills.mysign.toPay")}: {company.name}
        </p>
      ) : null}
    </div>
  );
};
